<template>
  <v-row no-gutters class="login-full">
    <v-col md="3" cols="12" >
      <!-- bank add -->
      <v-row no-gutters>
        <v-col md="12" cols="12" class="pt-3 pl-3 pr-3">
          <v-card>
            <v-card-text>
              <v-form ref="form" v-model="valid" v-on:submit.prevent lazy-validation>
              <v-radio-group
      v-model="onlineshopping.rgStatus"
      row
    >
      <v-radio
        label="Not Register"
        value="nr"
      ></v-radio>
      <v-radio
        label="B2B"
        value="btb"
      ></v-radio>
    </v-radio-group>
                <v-text-field
                  v-model="onlineshopping.name"
                  name="onlineshoppingName"
                  label="Name"
                  required
                  dense
                ></v-text-field>
                <v-autocomplete
                  v-model="onlineshopping.townshipDto.cityDto"
                  :rules="[v => !!v || 'City is required']"
                  name="onlineshoppingCity"
                  @change="getTownshipByCity"
                  item-text="cityName"
                  :items="cityList"
                  return-object
                  label="City"
                  class="my-3"
                  required
                  dense
                  v-if="false"
                >
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition mode="out-in">
                      <v-icon @click="goToCity" color="primary">add_circle</v-icon>
                    </v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  :rules="[v => !!v || 'Township is required']"
                  v-model="onlineshopping.townshipDto"
                  :disabled="!isTownshipByCity"
                  name="onlineshoppingTownship"
                  item-text="townshipName"
                  :items="townshipList"
                  label="Township"
                  return-object
                  required
                  dense
                  v-if="false"
                >
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition mode="out-in">
                      <v-icon
                        color="primary"
                        @click="$router.push({ name: 'township-city' }).catch(() => {});"
                      >add_circle</v-icon>
                    </v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>
                <v-text-field
                  v-model="onlineshopping.phone"
                  name="onlineshoppingPhone"
                  label="Phone"
                  required
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="onlineshopping.address"
                  name="onlineshoppingAddress"
                  label="Address"
                  required
                  dense
                ></v-text-field>
                <v-text-field

                  v-model="onlineshopping.latitude"
                  name="latitudelatitude"
                  label="Location"
                  required
                  dense
                ></v-text-field>
                <v-text-field
                v-if="false"
                  v-model="onlineshopping.longitude"
                  name="longlong"
                  label="Longitude"
                  required
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="onlineshopping.percent"
                  name="onlinespercnethoppingAddress"
                  label="Percentage(%)"
                  type="number"
                  required
                  dense
                  v-if="isStatus"
                ></v-text-field>
                <v-col v-if="isStatus">
                  <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="290px"
                  v-model="registerMenu"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="onlineshopping.registerDate"
                      label="Register Date"
                      prepend-icon="event"
                      hide-details
                      readonly
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="registerPicker"
                    @input="registerMenu = false"
                  ></v-date-picker>
                </v-menu>
                </v-col>
                <v-col v-if="isStatus">
                  <v-menu
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="290px"
                  v-model="expiredMenu"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="onlineshopping.expiredDate"
                      label="Expired Date"
                      prepend-icon="event"
                      hide-details
                      readonly
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="expiredPicker"
                    @input="expiredMenu = false"
                  ></v-date-picker>
                </v-menu>
                </v-col>
                <v-row no-gutters>
                <v-col md="6" cols="6">
              <v-switch dense v-model="onlineshopping.restaurant" name="onlineshopping.restaurant" label="Restaurant" color="primary"></v-switch>
                </v-col>
                <v-col md="6" cols="6">
              <v-switch dense v-model="onlineshopping.customer" name="onlineshopping.customer" label="Customer" color="primary"></v-switch>
                </v-col>
                </v-row>
                <v-btn
                  v-if="onlineshopping.status=='ADD'"
                  @click="addOnlineshopping()"
                  :disabled="!valid"
                  color="success"
                  class="ma-1"
                  depressed
                >
                  <v-icon>add</v-icon>
                  <span class="ml-2">Create</span>
                </v-btn>
                <v-btn
                  v-if="onlineshopping.status=='UPDATE'"
                  @click="updateOnlineshopping"
                  :disabled="!valid"
                  color="success"
                  class="ma-1"
                  depressed
                >
                  <v-icon>edit</v-icon>
                  <span class="ml-2">Update</span>
                </v-btn>
                <v-btn
                  v-if="onlineshopping.status=='UPDATE'"
                  @click="cancelOnlineshopping"
                  :disabled="!valid"
                  color="error"
                  class="ma-1"
                  depressed
                  outlined
                >
                  <v-icon>close</v-icon>
                  <span class="ml-2">Cancel</span>
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col md="9" cols="12" class="mt-3">
      <v-card>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6">
              
          <v-radio-group
      v-model="rgSearch"
      row
    >
      <v-radio
        label="All"
        value="all"
      ></v-radio>
      <v-radio
        label="B2B"
        value="btb"
      ></v-radio>
      <v-radio
        label="Not Register"
        value="nr"
      ></v-radio>
      <v-radio
        label="ExpiredDate"
        value="ed"
      ></v-radio>
    </v-radio-group>
            </v-col>
             <v-col md="4" cols="12" >
              <v-text-field
                append-icon="search"
                v-model="search"
                label="Search"
                name="search"
                hide-details
                single-line
              ></v-text-field>
            </v-col>
            <v-col md="12" cols="12" offset="0">
               <v-data-table
               :headers="onlineshoppingHeader"
                :items="onlineshoppingList"
                class="tbl-info"
                dense
          :items-per-page="-1"
          fixed-header
          mobile-breakpoint="sm"
          :headers-length="14"
          :search="search"
          height="75vh"
          hide-default-footer
          >
          <template
            v-slot:body="{ items, pagination }"
            v-if="onlineshoppingList.length > 0"
          >
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td class="text-left">{{ item.name }}
                </td>
                <td class="text-left">{{ item.phone }}
                </td>
                <td class="text-left">{{ item.address }}
                </td>
                <td class="text-center">{{ item.percent }}
                </td>
                <td class="text-center">{{ item.registerDate }}
                </td>
                <td class="text-center">{{ item.expiredDate }}
                </td>
                <td class="text-center">{{ item.restaurant }}
                </td>
                <td class="text-center">{{ item.customer }}
                </td>
                <td class="text-center">
                  <v-btn icon x-small  color="primary" @click="clickLocation(item)" v-if=" item.latitude!='' && item.latitude!=undefined  ">
                    <v-icon>location_on</v-icon>
                  </v-btn>
                  <v-btn icon x-small  color="primary" @click="clickHistory(item)">
                    <v-icon>history</v-icon>
                  </v-btn>
                 <v-btn icon x-small   color="primary" @click="editOnlineshopping(item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn icon x-small  color="error" @click="deleteOnlineshopping(item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
            </template>
          </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <v-bottom-sheet v-model="dialogOsHistory" fullscreen scrollable>
        <v-sheet class="fullscreen">
          <osHistoryDialog
            @closeDialog="dialogOsHistory=false"
            :restId="restId"
          />
        </v-sheet>
      </v-bottom-sheet>
    </v-col>
  </v-row>
</template>
<script>
import onlineshoppingService from "../service/OnlineshoppingService";
import osHistoryDialog from "@/components/OsHistoryDialog.vue";
export default {
  data() {
    return {
      dialogOsHistory:false,
      search: "",
      valid: false,
      validBank: false,
      isShowAddShop: false,
      isTownshipByCity: false,
      bank: {
        accountNo: "",
        status: "ADD",
        bankTypeDto: {}
      },
      onlineshoppingNameRule: [v => !!v || "Name is required"],
      bankNameRule: [v => !!v || "Bank Name is required"],
      addressRules: [v => !!v || "Address is required"],
      emailRule: [v => /.+@.+\..+/.test(v) || "E-mail must be valid"],
      bankListHeader: [
        { text: "Account Number", value: "accountNo" },
        { text: "Bank Type", value: "bankTypeDto.bankTypeName" },
        { text: "Action", value: "action" }
      ],
      onlineshoppingHeader: [
        { text: "Name", value: "name",sortable: false },
        // { text: "City", value: "townshipDto.cityDto.cityName" },
        // { text: "Township", value: "townshipDto.townshipName" },
        { text: "Phone", value: "phone",sortable: false },
        { text: "Address", value: "address",sortable: false },
        // { text: "Bank", value: "bankDto" },
        // { text: "Date", value: "date" },
        // { text: "Modified Date", value: "modifiedDate" },
         { text: "Percent(%)", value: "percent",sortable: false },
         { text: "Register Date", value: "registerDate",sortable: false },
         { text: "Expired Date", value: "expiredDate",sortable: false},
         { text: "Restaurant", value: "restaurant",sortable: false},
         { text: "Customer", value: "customer",sortable: false},
        { text: "Action", value: "action",sortable: false }
      ],
      onlineshopping: {
        rgStatus:'nr',
        restaurant:true,
        customer:true,
        status: "ADD",
        townshipDto: {
          cityDto: {
            cityName: ""
          }
        },
        bankDto: [
          {
            bankTypeDto: {
              bankTypeName: ""
            }
          }
        ]
      },
      onlineshoppingList: [
        {
          bankDto: [
            {
              bankTypeDto: {
                bankTypeName: ""
              }
            }
          ],
          townshipDto: {
            cityDto: {
              cityName: ""
            }
          }
        }
      ],
      bankList: [],
      cityList: [],
      bankTypeList: [],
      townshipList: [],
      expiredPicker: new Date().toISOString().substr(0, 10),
      expiredMenu: false,
      registerPicker: new Date().toISOString().substr(0, 10),
      registerMenu: false,
      isStatus:false,
      rgSearch:"all",
      realOsList:[],
      restId:0
    };
  },
  mounted: function() {
     this.onlineshopping.expiredDate = this.formatDate(this.expiredPicker);
     this.onlineshopping.registerDate = this.formatDate(this.registerPicker);
    this.getOnlineshopping();
    //this.getCity();
    //this.getBankType();
    if (this.$route.query.isShowAddShop != undefined) {
      this.isShowAddShop = this.$route.query.isShowAddShop == "true";
      // i++;
    }
  },
  methods: {
    clickLocation:function(item){
        window.open(item.latitude, "_blank");
    },
    clickHistory:function(item){
      this.restId = item.osId;
      this.dialogOsHistory = true;
    },
    formatDate(fromPicker) {
      const [year, month, day] = fromPicker.split("-");
      return `${day}-${month}-${year}`;
    },
    addOnlineshopping: function() {
      if (this.$refs.form.validate()) {
        this.onlineshopping.bankDto = this.bankList;
        onlineshoppingService
          .addOnlineshopping(this.onlineshopping)
          .then(() => {
            // this.$swal(
            //   "Successful",
            //   "Added New Onlineshopping Successful!",
            //   "success"
            // );
            this.$swal({
     title: "Successful",
     text: "Added New Onlineshopping Successful!",
     type: "success",
     timer: 500
     });
            this.getOnlineshopping();
            //this.$refs.form.reset();
            this.onlineshopping.name = "";
            this.onlineshopping.phone = "";
            this.onlineshopping.address = "";
            this.isShowAddShop = false;
          })
          .catch(err => {
            // if (this.onlineshopping.townshipDto.townshipId == undefined) {
            //   this.$swal("Failed", "Township is required", "error");
            // } else {
              this.$swal("Failed", err.response.data.message, "error");
           // }
          });
      }
    },
    editOnlineshopping: function(onlineshopping) {
      onlineshopping.status = "UPDATE";
      this.onlineshopping = Object.assign({}, onlineshopping);
      // townshipandCityService
      //   .getTownshipByCity(onlineshopping.townshipDto.cityDto.cityId)
      //   .then(response => {
      //     this.isTownshipByCity = true;
      //     this.townshipList.splice(0, this.townshipList.length);
      //     this.townshipList.push(...response);
      //     this.onlineshopping.townshipDto = Object.assign(
      //       {},
      //       onlineshopping.townshipDto
      //     );
      //     this.bankList.splice(0, this.bankList.length);
      //     this.bankList.push(...onlineshopping.bankDto);
      //     this.isShowAddShop = true;
      //     this.isTownshipByCity = true;
      //   });
    },
    updateOnlineshopping: function() {
      if (this.$refs.form.validate()) {
        // this.onlineshopping.bankDto.splice(
        //   0,
        //   this.onlineshopping.bankDto.length
        // );
        // this.onlineshopping.bankDto.push(...this.bankList);
        onlineshoppingService
          .updateOnlineshopping(this.onlineshopping)
          .then(() => {
            // this.$swal(
            //   "Updated Successful",
            //   "Onlineshopping is Updated!",
            //   "success"
            // );
            this.$swal({
     title: "Successful",
     text: "Onlineshopping is Updated!",
     type: "success",
     timer: 500
     });
            this.getOnlineshopping();
            //this.$refs.form.reset();
            this.onlineshopping.name = "";
            this.onlineshopping.phone = "";
            this.onlineshopping.address = "";
            this.onlineshopping.status = "ADD";
            this.isShowAddShop = false;
          })
          .catch(err => {
            this.$swal("Failed", err.response.data.message, "error");
          });
      }
    },
    deleteOnlineshopping: function(onlineshopping) {
      onlineshoppingService
        .deleteOnlineshopping(onlineshopping)
        .then(() => {
          this.getOnlineshopping();
          this.$refs.form.reset();
          this.onlineshopping.status = "ADD";
          // this.$swal(
          //   "Delete Successful",
          //   "Onlineshopping is Deleted!",
          //   "success"
          // );
          this.$swal({
     title: "Successful",
     text: "Onlineshopping is Deleted!",
     type: "success",
     timer: 500
     });
        })
        .catch(err => {
          if (err.response != undefined) {
            this.$swal(
              "Failed",
              "This data is used in somewhere Or " + err.response.data.message,
              "error"
            );
          }
        });
    },
    cancelOnlineshopping: function() {
      //this.bankList.splice(0, this.bankList.length);
      this.$refs.form.reset();
      this.onlineshopping = {
        townshipDto: {
          cityDto: {
            cityName: ""
          }
        }
      };
      this.onlineshopping.status = "ADD";
    },
    getOnlineshopping: function() {
      onlineshoppingService.getAllOnlineshopping().then(response => {
        this.rgSearch = "all";
        this.onlineshoppingList.splice(0, this.onlineshoppingList.length);
        this.onlineshoppingList.push(...response);
        this.realOsList.splice(0);
        this.realOsList.push(...response);
      });
    },
    getOsExpiredDate: function() {
      onlineshoppingService.getOsByExpiredDate().then(response => {
        this.onlineshoppingList.splice(0, this.onlineshoppingList.length);
        this.onlineshoppingList.push(...response);
      });
    },
    addBankAccount: function() {
      if (this.$refs.formBank.validate()) {
        var bankTemp = {
          bankId: Number(this.bankList.length) * -1,
          accountNo: this.bank.accountNo,
          bankTypeDto: this.bank.bankTypeDto
        };
        this.bankList.push(bankTemp);
        this.$refs.formBank.reset();
      }
    },
    updateBankAccount: function() {
      if (this.$refs.formBank.validate()) {
        var foundItem = this.bankList.find(item => {
          if (item.bankId == this.bank.bankId) {
            return item;
          }
        });
        Object.assign(foundItem, this.bank);
        this.$refs.formBank.reset();
        this.bank.status = "ADD";
      }
    },
    deleteBankAccount: function(bankAccount) {
      //this.bankList.splice(this.bankList.indexOf(bankAccount), 1);
      // this.$refs.formBank.reset();
      // this.bank.status = "ADD";
    },
    editBankAccount: function(bankAccount) {
      this.bank = Object.assign({}, bankAccount);
      this.bank.status = "UPDATE";
    },
    cancelUpdateBankAccount: function() {
      this.$refs.formBank.reset();
      this.bank = {};
      this.bank.status = "ADD";
    },
    getTownshipByCity: function() {
      // townshipandCityService
      //   .getTownshipByCity(this.onlineshopping.townshipDto.cityDto.cityId)
      //   .then(response => {
      //     this.isTownshipByCity = true;
      //     this.onlineshopping.townshipDto= response[0];
      //     this.townshipList.splice(0, this.townshipList.length);
      //     this.townshipList.push(...response);
      //   });
    },
    getCity: function() {
      // townshipandCityService.getCity().then(response => {
      //   this.cityList.splice(0, this.cityList.length);
      //   this.cityList.push(...response);
      // });
    },
    getBankType: function() {
      // bankTypeService.getBank().then(response => {
      //   this.bankTypeList.splice(0, this.bankTypeList.length);
      //   this.bankTypeList.push(...response);
      // });
    },
    showAddShop: function() {
      if (this.isShowAddShop == false) {
        this.isShowAddShop = true;
      } else {
        this.isShowAddShop = false;
      }
      this.onlineshopping = {
        townshipDto: {
          cityDto: {
            cityName: ""
          }
        }
      };
      this.onlineshopping.status = "ADD";
      this.changeRouter(this.isShowAddShop);
    },
    changeRouter: function(isShowAddShop) {
      let query = {
        isShowAddShop: isShowAddShop
      };
      this.$router
        .replace({
          name: "onlineshopping",
          query
        })
        .catch(() => {});
    },
    goToCity: function() {
      let query = {
        isShowCity: true
      };
      this.$router
        .push({
          name: "township-city",
          query
        })
        .catch(() => {});
    }
  },
   watch: {
      expiredPicker() {
      this.onlineshopping.expiredDate = this.formatDate(this.expiredPicker);
    },
    registerPicker() {
      this.onlineshopping.registerDate = this.formatDate(this.registerPicker);
    },
    "onlineshopping.rgStatus":function(){
      if(this.onlineshopping.rgStatus=="nr"){
        this.isStatus = false;
      }else{
        this.isStatus = true;
      }
    },
    rgSearch(){
      this.onlineshoppingList.splice(0, this.onlineshoppingList.length);
      if("all" == this.rgSearch){
          this.onlineshoppingList.push(...this.realOsList);
      }else if("btb" == this.rgSearch){
        for(var i=0;i<this.realOsList.length;i++){
          var tempOs = this.realOsList[i];
          if(tempOs.rgStatus == "btb"){
            this.onlineshoppingList.push(tempOs);
          }
        }
      }else if("nr" == this.rgSearch){
        for(var i=0;i<this.realOsList.length;i++){
          var tempOs = this.realOsList[i];
          if(tempOs.rgStatus == "nr"){
            this.onlineshoppingList.push(tempOs);
          }
        }
      }else {
        this.getOsExpiredDate();
      }
    }
    },
    components: {osHistoryDialog},
};
</script>
<style scoped>
.v-data-table td,
.v-data-table th {
  padding: 0 2px !important;
}
.information-window-v-sheet {
  height: 100vh !important;
  overflow-x: scroll;
}
.login-full {
  height: 92vh;
}
.fullscreen {
  height: 100vh !important;
  overflow-x: scroll;
}
</style>